import React, { useState } from 'react';
import {  FaTrash, FaPlus, FaSave, FaDownload } from 'react-icons/fa';
import './ApplicationAdmin.css';

const ApplicationAdmin = () => {
  const [applications, setApplications] = useState([
    
  ]);

  const [editingApp, setEditingApp] = useState(null);
  const [newApplication, setNewApplication] = useState({
    applicationId: '',
    applicantName: '',
    email: '',
    submissionDate: '',
    status: 'In Review',
  });
  const [notification, setNotification] = useState('');

  const handleDelete = (applicationId) => {
    setApplications(applications.filter((app) => app.applicationId !== applicationId));
  };

  const handleAddNew = () => {
    setApplications([...applications, { ...newApplication, applicationId: Date.now().toString() }]);
    setNewApplication({ applicationId: '', applicantName: '', email: '', submissionDate: '', status: 'In Review' });
  };

  const handleUpdateStatus = (applicationId, status) => {
    setApplications(
      applications.map((app) =>
        app.applicationId === applicationId ? { ...app, status } : app
      )
    );
    setNotification('Application status successfully updated!');
  };

  const handleSaveEdit = () => {
    setApplications(
      applications.map((app) =>
        app.applicationId === editingApp.applicationId ? editingApp : app
      )
    );
    setEditingApp(null);
  };

  const handleDownload = (applicationId) => {
    setNotification('File downloaded for application ' + applicationId);
  };

  return (
    <div className="application-admin-container">
      <h1>Application Management</h1>

      {/* Add New Application Form */}
      <div className="form-container">
        <h3><FaPlus /> Add New Application</h3>
        <div className="input-group">
          <label>Applicant Name</label>
          <input
            type="text"
            placeholder="Enter applicant name"
            value={newApplication.applicantName}
            onChange={(e) => setNewApplication({ ...newApplication, applicantName: e.target.value })}
          />
        </div>
        <div className="input-group">
          <label>Email</label>
          <input
            type="email"
            placeholder="Enter applicant email"
            value={newApplication.email}
            onChange={(e) => setNewApplication({ ...newApplication, email: e.target.value })}
          />
        </div>
        <div className="input-group">
          <label>Submission Date</label>
          <input
            type="date"
            value={newApplication.submissionDate}
            onChange={(e) => setNewApplication({ ...newApplication, submissionDate: e.target.value })}
          />
        </div>
        <button onClick={handleAddNew}><FaSave /> Save Application</button>
      </div>

      {/* Notifications */}
      {notification && <div className="notification-message">{notification}</div>}

      {/* Applications Table */}
      <div className="applications-list">
        <h3>All Applications</h3>
        <table className='tableX'>
          <thead>
            <tr>
              <th>Application ID</th>
              <th>Applicant Name</th>
              <th>Email</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {applications.map((app) => (
              <tr key={app.applicationId}>
                <td>{app.applicationId}</td>
                <td>{app.applicantName}</td>
                <td>{app.email}</td>
                <td>
                  <select
                    value={app.status}
                    onChange={(e) => handleUpdateStatus(app.applicationId, e.target.value)}
                  >
                    <option value="In Review">In Review</option>
                    <option value="Approved">Approved</option>
                    <option value="Rejected">Rejected</option>
                  </select>
                </td>
                <td>
                  <button onClick={() => handleUpdateStatus(app.applicationId, app.status)}><FaSave /> Update</button>
                  <button onClick={() => handleDelete(app.applicationId)}><FaTrash /> Delete</button>
                  <button onClick={() => handleDownload(app.applicationId)}><FaDownload /> Download</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Edit Application Modal */}
      {editingApp && (
        <div className="edit-modal">
          <h3>Edit Application</h3>
          <div className="input-group">
            <label>Applicant Name</label>
            <input
              type="text"
              value={editingApp.applicantName}
              onChange={(e) => setEditingApp({ ...editingApp, applicantName: e.target.value })}
            />
          </div>
          <div className="input-group">
            <label>Email</label>
            <input
              type="email"
              value={editingApp.email}
              onChange={(e) => setEditingApp({ ...editingApp, email: e.target.value })}
            />
          </div>
          <div className="input-group">
            <label>Submission Date</label>
            <input
              type="date"
              value={editingApp.submissionDate}
              onChange={(e) => setEditingApp({ ...editingApp, submissionDate: e.target.value })}
            />
          </div>
          <button onClick={handleSaveEdit}><FaSave /> Save Changes</button>
        </div>
      )}
    </div>
  );
};

export default ApplicationAdmin;